<template>
  <div
    class="py-16 bg-center bg-no-repeat bg-cover"
    style="background-image: url('/storage/image/section.jpg')"
    v-if="user && (user.subscription_status !== 'active' || user.with_gift)"
  >
    <div class="container mx-auto flex flex-col items-center justify-center px-4">
      <h2 class="text-white font-shadow-sm font-extrabold text-2xl lg:text-4xl xl:text-4xl mb-4 uppercase text-center">{{ $t('messages.general.subscribe_today')}}</h2>
      <p class="text-white font-shadow-sm font-bold text-base md:text-xl lg:text-xl xl:text-xl max-w-3xl mx-auto mb-10 text-center">{{ $t('messages.general.subscribe_message')}}</p>
      <router-link
        class="mx-auto bg-jblue-primary text-white hover:text-jblue-primary font-semibold rounded py-2 px-12 block text-center text-base hover:bg-white border border-jblue-primary "
        to="/subscriptions"
      >{{ $t('messages.general.subscribe')}}</router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "BannerSubscribe",
  computed: {
    ...mapState("auth", ["user"])
  }
};
</script>

<style scoped>

.font-shadow-sm {
  text-shadow: 5px 5px 13px rgba(0,0,0,0.2);
}
</style>
